import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Statements from "@/pages/Statements";
import StatementDetail from "@/pages/StatementDetail";
import Receipts from "@/pages/Receipts";
import Matching from "@/pages/Matching";
import Analytics from "@/pages/Analytics";
import ApiKeys from "@/pages/ApiKeys";
import Team from "@/pages/Team";
import MemberDetail from "@/pages/MemberDetail";
import Settings from "@/pages/Settings";
import Archive from "@/pages/Archive";
import MissingReceipts from "@/pages/MissingReceipts";
import Vehicles from "@/pages/Vehicles";
import AiReview from "@/pages/AiReview";
import EmailImport from "@/pages/EmailImport";
import TelegramSettings from "@/pages/TelegramSettings";
import Contracts from "@/pages/Contracts";

function MemberDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={`/app/einstellungen/mitarbeiter/${id}`} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Navigate to="/app" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="firmen" element={<Companies />} />
              <Route path="kontoauszuege" element={<Statements />} />
              <Route path="kontoauszuege/:id" element={<StatementDetail />} />
              <Route path="belege" element={<Receipts />} />
              <Route path="vertraege" element={<Contracts />} />
              <Route path="fehlende-belege" element={<MissingReceipts />} />
              <Route path="fahrzeuge" element={<Vehicles />} />
              <Route path="archiv" element={<Archive />} />
              <Route path="zuordnung" element={<Matching />} />
              <Route path="auswertung" element={<Analytics />} />
              <Route path="team" element={<Navigate to="/app/einstellungen/mitarbeiter" replace />} />
              <Route path="team/:id" element={<MemberDetailRedirect />} />
              <Route path="ki-pruefung" element={<Navigate to="/app/einstellungen/ki-pruefung" replace />} />
              <Route path="email-import" element={<Navigate to="/app/einstellungen/email" replace />} />
              <Route path="api-keys" element={<Navigate to="/app/einstellungen/api-keys" replace />} />
              <Route path="einstellungen" element={<Settings />}>
                <Route path="telegram" element={<TelegramSettings />} />
                <Route path="mitarbeiter" element={<Team />} />
                <Route path="mitarbeiter/:id" element={<MemberDetail />} />
                <Route path="email" element={<EmailImport />} />
                <Route path="ki-pruefung" element={<AiReview />} />
                <Route path="api-keys" element={<ApiKeys />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
